module.exports = __webpack_public_path__ + "img/Weapon_53.02ace83d.png";